import useOrientation from "../hooks/useOrientation";
import useDeviceType from "../hooks/useDeviceType";

import DesktopLayout from "../layouts/DesktopLayout";
import MobileLayout from "../layouts/MobileLayout";


export default function Home() {

  const device = useDeviceType();


  // --- LOGICA DECISIONALE ---

  // Desktop → sempre desktop
  if (device === "desktop") {
    return <DesktopLayout  />;
  }

  // Tablet o telefono in portrait → layout retro dedicato
  // if (orientation === "portrait") {
    return <MobileLayout />;
  // }

  // Tablet o telefono landscape → quasi desktop
  // return <DesktopLikeOnMobile />;
}
